import { render, staticRenderFns } from "./withdrawalLog.vue?vue&type=template&id=47d2a6f2&scoped=true&"
import script from "./withdrawalLog.vue?vue&type=script&lang=js&"
export * from "./withdrawalLog.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalLog.vue?vue&type=style&index=0&id=47d2a6f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d2a6f2",
  null
  
)

export default component.exports